import { Shape, Vector3 } from 'three'
import { useMeasures } from '../../../../../hooks/state/useMeasures'
import { useRoof } from '../../../../../hooks/state/useRoof'
import { CachedMeshPhysicalMaterial } from '../../../../material/cachedMeshPhysicalMaterial'
import { Helper } from '../../../../../classes/helper'

export const SinusPlatte = (): JSX.Element => {
  const {
    metalColor,
    roofGlassDepth,
    roughness,
    amplitude,
    frequenz,
    slatAngle,
  } = useRoof()
  const { userWidth, verandaTyp, depth, isQubus, roofLogWidth } = useMeasures()
  const plateRotation = slatAngle

  const lenght = plateRotation
    ? isQubus
      ? userWidth - verandaTyp.log.width
      : userWidth - verandaTyp.roofBar.depth * 2
    : isQubus
    ? depth - verandaTyp.log.depth * 2
    : roofLogWidth

  const width = plateRotation
    ? depth - verandaTyp.log.depth * 2
    : userWidth - verandaTyp.log.width

  const step = 0.01
  const amp = amplitude / 200
  const freq = 1 / (frequenz / 620)
  let x = 0

  const platePosition = new Vector3(
    plateRotation ? -lenght / 2 : -width / 2,
    amp + verandaTyp.roofBar.width / 2 - roofGlassDepth,
    plateRotation ? width : 0
  )

  const shape = new Shape()
  shape.moveTo(0, 0)
  while (width > x) {
    x += step
    shape.lineTo(x, roofGlassDepth / 2 + amp * Math.sin(x * freq))
  }
  while (x >= 0) {
    shape.lineTo(x, -roofGlassDepth / 2 + amp * Math.sin(x * freq))
    x -= step
  }

  const extrudeSettings = {
    steps: 2,
    depth: lenght,
    bevelEnabled: false,
    bevelThickness: 1,
    bevelSize: 1,
    bevelOffset: 0,
    bevelSegments: 1,
  }

  return (
    <mesh
      key={`sinusPlatte`}
      position={platePosition}
      castShadow={true}
      receiveShadow={false}
      rotation={[0, Helper.convertAngleToRadiant(plateRotation ? 90 : 0), 0]}
    >
      <extrudeGeometry args={[shape, extrudeSettings]} />

      <CachedMeshPhysicalMaterial
        color={metalColor}
        roughness={roughness}
        metalness={0.5}
      />
    </mesh>
  )
}
